exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-309349d6] .el-dialog__body{max-height:580px;overflow:auto}[data-v-309349d6] .is-fullscreen{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[data-v-309349d6] .is-fullscreen .el-dialog__body{-webkit-box-flex:1;-ms-flex:1;flex:1;max-height:100% !important}.operate-btn[data-v-309349d6]{margin:2px}\n", ""]);

// exports
